export default __webpack_public_path__ + "static/media/MX.e9520a60.svg";